import Landing from "./Landing"
import Navbar from './Navbar';
import About from './About';
import './Stylesheets/App.css';
import ContactPro from "./Contact";
import FooterPro from "./FooterPro";

 
function App() {
  return (
    <div className="App">
 <Navbar />
<Landing />
<About />
<ContactPro />
<FooterPro />
    </div>
  );
}

export default App;
